let currentCaptchaConfig = {}
/** 是否打印日志 */
const isPrintLog = false

// const defaultBgImageWidth = 257
// const defaultBgImageHeight = 140
// const defaultSliderBtnWidth = 68
// const defaultSliderBtnHeight = 50

function clearPreventDefault(event) {
  if (event.preventDefault) {
    event.preventDefault()
  }
}

export function clearAllPreventDefault($div) {
  $div.addEventListener('touchmove', clearPreventDefault, false)
}

export function reductionAllPreventDefault($div) {
  $div.removeEventListener('touchmove', clearPreventDefault)
}

export function printLog(...params) {
  if (isPrintLog) {
    console.log(params)
  }
}

export function initConfig(bgImageWidth, bgImageHeight, sliderBtnWidth, sliderBtnHeight, end) {
  currentCaptchaConfig = {
    bgImageWidth, // 背景图宽度
    bgImageHeight, // 背景图高度
    sliderBtnWidth, // 滑块宽度
    sliderBtnHeight, // 滑块高度
    end, // 可滑行终点
    startTime: new Date(),
    trackArr: [],
    movePercent: 0
  }
  printLog('init', currentCaptchaConfig)
  return currentCaptchaConfig
}

// 按下
export function down(event, callback) {
  const targetTouches = event.originalEvent ? event.originalEvent.targetTouches : event.targetTouches
  let startX = event.pageX
  let startY = event.pageY
  if (startX === undefined) {
    startX = Math.round(targetTouches[0].pageX)
    startY = Math.round(targetTouches[0].pageY)
  }
  currentCaptchaConfig.startX = startX
  currentCaptchaConfig.startY = startY

  const pageX = currentCaptchaConfig.startX
  const pageY = currentCaptchaConfig.startY
  const startTime = currentCaptchaConfig.startTime
  const trackArr = currentCaptchaConfig.trackArr
  trackArr.push({
    x: pageX - startX,
    y: pageY - startY,
    type: 'down',
    t: new Date().getTime() - startTime.getTime()
  })
  printLog('start', startX, startY)
  callback && callback(currentCaptchaConfig)
}

// 移动
export function move(event, callback) {
  if (event instanceof TouchEvent) {
    event = event.touches[0]
  }
  const pageX = Math.round(event.pageX)
  const pageY = Math.round(event.pageY)
  const startX = currentCaptchaConfig.startX
  const startY = currentCaptchaConfig.startY
  const startTime = currentCaptchaConfig.startTime
  const end = currentCaptchaConfig.end
  const bgImageWidth = currentCaptchaConfig.bgImageWidth
  const trackArr = currentCaptchaConfig.trackArr
  let moveX = pageX - startX
  const track = {
    x: pageX - startX,
    y: pageY - startY,
    type: 'move',
    t: new Date().getTime() - startTime.getTime()
  }
  trackArr.push(track)
  if (moveX < 0) {
    moveX = 0
  } else if (moveX > end) {
    moveX = end
  }
  currentCaptchaConfig.moveX = moveX
  currentCaptchaConfig.movePercent = moveX / bgImageWidth
  callback && callback(currentCaptchaConfig)
  printLog('move', track)
}

// 抬起
export function up(event, callback) {
  window.removeEventListener('mousemove', move)
  window.removeEventListener('mouseup', up)
  window.removeEventListener('touchmove', move)
  window.removeEventListener('touchend', up)
  if (event instanceof TouchEvent) {
    event = event.changedTouches[0]
  }
  currentCaptchaConfig.stopTime = new Date()
  const pageX = Math.round(event.pageX)
  const pageY = Math.round(event.pageY)
  const startX = currentCaptchaConfig.startX
  const startY = currentCaptchaConfig.startY
  const startTime = currentCaptchaConfig.startTime
  const trackArr = currentCaptchaConfig.trackArr

  const track = {
    x: pageX - startX,
    y: pageY - startY,
    type: 'up',
    t: new Date().getTime() - startTime.getTime()
  }

  trackArr.push(track)
  printLog('up', track)
  callback && callback(currentCaptchaConfig)
}
